import { render, staticRenderFns } from "./SampleStatusInput.vue?vue&type=template&id=13d15b78&scoped=true&"
import script from "./SampleStatusInput.vue?vue&type=script&lang=js&"
export * from "./SampleStatusInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d15b78",
  null
  
)

export default component.exports